import { useEffect } from "react";
import { useSubscriptionClient } from "./context.js";
/**
 * A hook to set up a GraphQL subscription with callbacks.
 *
 * @example
 * ```tsx
 * useSubscribe({
 *   document: MySubscriptionDocument,
 *   variables: { id: '123' },
 *   next: ({ data }) => console.log('Received:', data),
 *   error: (err) => console.error('Error:', err),
 * });
 * ```
 */
export const useSubscribe = (options) => {
    const subs = useSubscriptionClient();
    useEffect(() => {
        if (options.enabled === false)
            return;
        return subs?.subscribe(options);
    }, [subs, options]);
};
//# sourceMappingURL=useSubscribe.js.map